import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Header from './Header';
import Loader from './Loader';
import Menu from './Menu';
import NextPrev from "./NextPrev";
import $ from "jquery";
import '../assets/css/question.css';
import { CONFIG } from '../helpers/Common';

class CheifComplainLocation extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {
            complainDetails:this.props.getComplainData.complainTypeDetails,
            imageView:"front",
            currentImage:"",
            coordinate_x:"",
            coordinate_y:"",
            nextStep:4,
            prevStep:2,
            imgPath: CONFIG.COMPLAIN_IMAGE_PATH,
        };
        this.handlePrevAction   = this.handlePrevAction.bind(this);
        this.handleAction       = this.handleAction.bind(this);
        this.markPositionOld    = this.markPositionOld.bind(this);
        
    }

    componentWillMount() {

        let complainData            = this.state.complainDetails;
        let complainLocationData    = this.props.getComplainLocationData;
        
        if(complainLocationData)
        {   
            this.setState({ 
                coordinate_x    :complainLocationData.coordinate_x,
                coordinate_y    :complainLocationData.coordinate_y,
                imageView       :complainLocationData.image_view,
                currentImage    :complainLocationData.image,
                picCoordinates  :complainLocationData.picCoordinates
            });
            
        }
        else
        {
            this.setState({ 
                currentImage    :complainData.image_front,
            });
        }
        this.resize();
    }
    
    handleImageView = (e)=>{
        if(this.state.imageView=='front')
        {
            this.setState({ 
                imageView :'back',
                currentImage    : this.state.complainDetails.image_back,
            });
        }
        else
        {
            this.setState({ 
                imageView :'front',
                currentImage    : this.state.complainDetails.image_front,
            });
        }
        $(".marker").remove();
        this.setState({
            coordinate_x:'',
            coordinate_y:'',
        })
    }

    handleAction = (e)=>{
        
        if(this.state.coordinate_x==''|| this.state.coordinate_y=='')
        {
            alert("Please select area in Image");
        } 
        else
        {   
            $(".marker").remove();
            let data = ({
                image_view      : this.state.imageView,
                image           : this.state.currentImage,
                coordinate_x    : this.state.coordinate_x,
                coordinate_y    : this.state.coordinate_y,
            });
            $(".marker").remove();
            this.props.setComplainLocation(data);
            this.props.handleNextPrev(this.state.nextStep);
        }
        $(".marker").remove();

    }
    handlePrevAction = (e)=>{
        this.props.handleNextPrev(this.state.prevStep);
        $(".marker").remove();
    }

    changeImage = () => {
        $(".marker").remove();
        let tempImage = !this.state.frontImage;
        this.setState({
          frontImage: tempImage
        });
    };

    resize = () => {
        
        if(this.state.coordinate_x !== "" || this.state.coordinate_y !== "") this.markPositionOld();
    }

    componentDidMount() {
        this.resize();
        window.addEventListener('resize', this.resize)
        
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize)
    }
 
    mark(picCoordinates, top, left) {
        let markerRadius = 13;
        $(".marker").remove();
        $("body").append(
            $('<div class="marker"></div>').css({
                position: "absolute",
                top: top + picCoordinates.y - markerRadius / 2 + "px",
                left: left + picCoordinates.x - markerRadius / 2 + "px",
                width: markerRadius + 'px',
                height: markerRadius + 'px',
                backgroundColor: "#990000",
                borderRadius: '50%',
                display: 'inline-block',
            })
        );
    }

    markPositionOld = () => {
        var picCoordinates = document.getElementById('pic').getBoundingClientRect();
        this.mark(picCoordinates, this.state.coordinate_y, this.state.coordinate_x);
    };

    markPosition = ev => {
        var picCoordinates = document.getElementById('pic').getBoundingClientRect();
        let offsetX = ev.pageX - picCoordinates.x;
        let offsetY = ev.pageY - picCoordinates.y;
        this.mark(picCoordinates, offsetY, offsetX);
        this.setState({
            coordinate_x: offsetX,
            coordinate_y: offsetY,
        })
    };

    render() {
    return (
        
        <React.Fragment>
            <Header title="Patient Symptoms Narrative" titleImage="ic-medical-result.png" />
            <Menu />
            <section className="chief-complain sec--question">
                <div className="questionrow">
                    <div className="question">
                        <label>Question</label>
                        <h3>What is the location of {this.state.complainDetails.name}?</h3>
                    </div>
                </div>
                <div className="male-model-complain">
                    <div className="container">
                        <div className="male-img">
                            <img  onClick={this.markPosition} id="pic" src={this.state.imgPath+this.state.currentImage} alt=""/>
                            <div className="view-btn">
                                <Link to="#" onClick={this.handleImageView} >
                                    <img src={require("../assets/img/icons/ic-refresh.png")} alt=""/>
                                </Link>     
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <NextPrev handleNextAction={this.handleAction} next={this.state.nextStep} prev={this.state.prevStep} handlePrevAction={this.handlePrevAction} />
            
        </React.Fragment>
    );
  }
}

export default CheifComplainLocation;